/**
 * Route Configuration
 *
 * Defines the screen types and their access control rules.
 * Maps each screen to authentication requirements and user type permissions.
 */

import { RouteConfig, ScreenType } from '@/types/auth';

/**
 * Route configuration mapping screens to their access rules.
 *
 * - LOGIN: Public screen, only accessible when NOT authenticated
 * - DASHBOARD: Protected screen for all authenticated users
 * - COMING_SOON: Protected screen (reserved for future use)
 */
export const routeConfig: Record<ScreenType, RouteConfig> = {
  [ScreenType.LOGIN]: {
    screen: ScreenType.LOGIN,
    requiresAuth: false,
    publicOnly: true, // Only unauthenticated users can access
  },
  [ScreenType.DASHBOARD]: {
    screen: ScreenType.DASHBOARD,
    requiresAuth: true,
    publicOnly: false,
  },
  [ScreenType.COMING_SOON]: {
    screen: ScreenType.COMING_SOON,
    requiresAuth: true,
    publicOnly: false,
  },
};
